import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  host: { '[class]': 'type()' },
  imports: [MatIcon],
  selector: 'avs-message',
  styleUrl: './message.component.scss',
  templateUrl: './message.component.html',
})
export class MessageComponent {
  type = input<'info' | 'warning'>('info');
}
